module.exports = __webpack_public_path__ + "static/img/mould5.43bddfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexEditor/mould/mould5.png
// module id = YIl9
// module chunks = 3